import api from "./api";

const BASE_ENDPOINT = '/convenia';

/**
 * Sincroniza os departamentos com o convenia
 */
function syncDepartamentos() {
    return api.post(`${BASE_ENDPOINT}/atualizar/departamentos`);
}

/**
 * Sincroniza as funcoes com o convenia
 */
function syncFuncoes() {
    return api.post(`${BASE_ENDPOINT}/atualizar/funcoes`);
}

/**
 * Sincroniza todos os colaboradores com o convenia
 */
function syncTodosColaboradores() {
    return api.post(`${BASE_ENDPOINT}/colaborador/sincronizar/todos`);
}

/**
 * Sincroniza os regimes de contrato com o convenia
 */
function syncRegimes() {
    return api.post(`${BASE_ENDPOINT}/atualizar/regimes`);
}


/**
 * Consulta status das sincronizações com o Convenia
 */
function consultaStatusSincronizacao(tipo) {
    return api.get(`${BASE_ENDPOINT}/sincronizacao/status/${tipo}`);
}

export {
    syncDepartamentos,
    syncFuncoes,
    syncRegimes,
    syncTodosColaboradores,
    consultaStatusSincronizacao,
}